export const text = {
  defaultMsg: "Can't accomplish the action at the moment.",
  userGroup: "Can't show user group list at the moment.",
  userOrgSuggestions: "Can't show user organization suggestions at the moment.",
  defaultDelete: "Can't delete user at the moment.",
  noReason: 'You need enter the reason for this delete action.',
  noUser: "Sorry, We can' find this user.",
  defaultUpdatePassword: "Can't update password at the moment.",
  wrongEmail: "We can't find this user. Please contact administrator.",
  noPassword: 'Please provide current passwords and the new one.',
  wrongNewPass: 'New password should be different of current one.',
  wrongCurrentPass:
    'The password you have entered does not match your current one.',
  internalError:
    "Couldn't update new user. Please check that all entered data is valid",
  invalidFirstName: 'Could not update user. Invalid First Name',
  invalidLastName: 'Could not update user. Invalid Last Name',
  invalidJobTitle: 'Could not update user. Invalid Job Title',
  invalidEmployerNumber: 'Could not update user. Invalid Employer Number',
  invalidDateTimeFormat: 'Could not update user. Invalid DateTime Format',
  invalidPhone: 'Could not update user. Invalid Phone',
  generalError: 'Sorry, could not update user at the moment.',
  dateTimeAfterNow: 'Could not update user. Datetime is after now',
  userExist:
    'User with specified details already exists. Please check the list of users for possible duplications',
  unlockEmptyId: 'Unlock reason id can not be empty.',
  unlockReasonNotFound: 'Unlock reason with specified id is not found',
  unlockUserNotFound: 'User does not exist',
  unlockInvalidStatus: 'Existing user status is invalid',
  unlockNoEmail: "Can't reset password for user without email.",
  userNotAuthorized: 'User is not authorized, can not perform the action',
  userNotExists: 'User does not exist',
  extUserNotAssignedToAnyOrganization:
    'External user is not assigned to any organization'
};

export default text;
